// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"358":"live-streaming","594":"about","977":"medical-code"}[chunkId] || chunkId) + "." + {"358":"17a3ecb1","551":"c541c1de","594":"b74c371d","977":"5803b0b5"}[chunkId] + ".css";
};